import JsonLdHomecardListCarousel from './JsonLdHomecardListCarousel';

export default JsonLdHomecardListCarousel;
